import { FormattedHTMLMessage } from "react-intl";

import { useMessage } from "@/components/Message";
import { getFieldConfigByFieldId } from "@/lib/utils/stepComponentHelpers/stepComponentHelpers";

import { type FormFieldComponentProps } from "../../../lib/types/types";
import { FormFieldText } from "../FormFieldText/FormFieldText";

interface FormFieldTextProps extends FormFieldComponentProps {
  explanation?: string | JSX.Element;
}

export const AddressComponent = ({
  value,
  isErrored,
  onChange,
  isRequired = false,
  onKeyDown = undefined,
  placeholder = "",
  label,
  explanation = "",
  disabled = false,
}: FormFieldTextProps) => {
  const { msg } = useMessage();
  const isFieldHidden = getFieldConfigByFieldId("address1")?.hidden;

  if (isFieldHidden) {
    return null;
  }

  return (
    <FormFieldText
      fieldId="address"
      value={value}
      onChange={onChange}
      placeholder={placeholder || msg({ id: "addressPlaceholder" })}
      label={label || <FormattedHTMLMessage id="address" defaultMessage="Address" />}
      errorMessage={
        isErrored && (
          <FormattedHTMLMessage id="errorId.invalidAddress" defaultMessage="Invalid address" />
        )
      }
      showPlaceholderAndHideLabel={!!placeholder}
      required={isRequired}
      onKeyDown={typeof onKeyDown === "function" ? (e) => onKeyDown(e) : undefined}
      explanation={explanation}
      disabled={disabled}
      autoComplete="street-address"
    />
  );
};
